exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".basfLogo {\n\tbackground-image: url(/assets/images/logo.svg);\n\tbackground-position: left top;\n\tbackground-repeat: no-repeat;\n\tbackground-origin: content-box;\n\tbackground-size: contain;\n\theight: 40px;\n\twidth: 100%;\n\tmargin-bottom: 10px;\n}\n", ""]);

// exports
